import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "13",
  viewBox: "0 0 8 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.02876 1.02864C1.28911 0.768287 1.71122 0.768287 1.97157 1.02864L6.97157 6.02864C7.23192 6.28899 7.23192 6.7111 6.97157 6.97145L1.97157 11.9714C1.71122 12.2318 1.28911 12.2318 1.02876 11.9714C0.768409 11.7111 0.768409 11.289 1.02876 11.0286L5.55735 6.50004L1.02876 1.97145C0.768409 1.7111 0.768409 1.28899 1.02876 1.02864Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }